import bsCustomFileInput from "bs-custom-file-input";
import initReferentNotes from "../util/referentNotes";
const enable = window.enable;

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Detect touchscreen or not
    if (!window.matchMedia("(pointer: coarse)").matches) {
      $('[data-toggle="tooltip"]').tooltip();
    }

    $("p:empty").remove();

    var jQueryValidationlanguage = $("html").attr("lang");
    if (jQueryValidationlanguage != undefined) {
      jQueryValidationlanguage = jQueryValidationlanguage.split("-")[0];
      $.getScript(
        "https://ajax.aspnetcdn.com/ajax/jquery.validate/1.19.3/localization/messages_" +
          jQueryValidationlanguage +
          ".js"
      );

      // $.validator.messages.maxsize = 'SVP select no more than {0} files.';
      // console.log(enable);
      // console.log($.validator.messages);

      Object.entries(enable.validator.messages).forEach(function (element) {
        $.validator.messages[element[0]] = element[1];
      });

      // for (const [key, value] of Object.entries(enable.validator.messages)) {
      //   console.log(key +':'+ value);
      // };

      // $.validator.messages = Object.assign(enable.validator.messages, $.validator.messages);
      // $.validator.messages = Object.assign($.validator.messages, enable.validator.messages);

      // console.log($.validator.messages);
    }

    $(function () {
      bsCustomFileInput.init();
    });

    // Init inline edit for referent notes (profile table)
    initReferentNotes();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js